import { HttpClient } from 'components/http/HttpClient';
import { IAwardsResponse } from './models';
import { isString } from 'lib/typeInference';
import { AxiosRequestConfig } from 'axios';

class AwardsApi extends HttpClient {
    constructor() {
        super({ baseURL: process.env.API_SERVER_URL, url: '/awards' });
    }

    public getAwards(forceIncludeLoyaltyBalance?: boolean, locationId?: string): Promise<IAwardsResponse> {
        const params: AxiosRequestConfig['params'] = {};
        if (forceIncludeLoyaltyBalance) {
            params.forceIncludeLoyaltyBalance = forceIncludeLoyaltyBalance;
        }
        if (isString(locationId)) {
            params.locationId = locationId;
        }
        return this.getRequest<IAwardsResponse>({
            url: '',
            headers: { 'x-api-version': '7' },
            configs: {
                params
            }
        });
    }
}
export const awardsApi = new AwardsApi();
